<mpro-top-bar #topBar class="top-bar"></mpro-top-bar>
<div #stickyHeader class="sticky-header">
  <mpro-header
    (yearSliderErrorEmitter)="setError($event)"
    id="first-step"
  ></mpro-header>
  <mpro-alert
    class="main-alert"
    *ngIf="yearSliderError"
    [type]="'error'"
    [message]="yearSliderError"
  ></mpro-alert>
</div>
<div #container class="container-xl">
  <mpro-breadcrumbs
    [breadcrumbs]="breadcrumbs$ | async"
    (breadcrumbClicked)="breadcrumbSelected($event)"
  ></mpro-breadcrumbs>
  <div
    class="export-data-btn"
    [style.visibility]="exportDataModal ? 'hidden' : 'visible'"
    *ngIf="authService.permissions$ | async as plan"
  >
    <button
      #exportDataBtn
      blockOnClickEvent
      [condition]="
        !(authService._userRoles$ | async)?.export || plan.isFreemium || false
      "
      [callback]="
        plan.isFreemium ? authService.openFreemiumRequestModal : undefined
      "
      [requestCategory]="'Export data'"
      (click.checkBlockEvent)="openExportData()"
      class="mpro-btn mpro-btn-primary"
    >
      <fa-icon
        [icon]="faSignInAlt"
        class="fa-rotate-90 export-data-icon"
      ></fa-icon>
      <span>export data</span>
      <fa-icon
        *ngIf="!authService.isLoggedIn() || plan.isFreemium"
        [icon]="faLock"
        class="lock"
      ></fa-icon>
    </button>
  </div>
  <div class="row">
    <div id="content" class="col-12 col-lg-4 order-last order-lg-first">
      <div class="mt-4 mpro-box" id="third-step">
        <!-- Hiding the Consumer Spending component using CSS instead of removing it from the DOM. 
          This prevents rendering issues that occur when the component is removed completely. -->
        <mpro-consumer-demand
          [ngClass]="isCategoriesEnabled ? '' : 'hidden'"
        ></mpro-consumer-demand>
        <mpro-consumer-spending
          [ngClass]="isCategoriesEnabled ? 'hidden' : ''"
        ></mpro-consumer-spending>
      </div>
      <div
        class="mt-4 mpro-box"
        id="fourth-step"
        *ngIf="
          !isCategoriesEnabled &&
          (authService.permissions$ | async)?.isFreemium &&
            isIncomeGroupSelected()
        "
      >
        <mpro-age-and-gender></mpro-age-and-gender>
      </div>
      <div class="mt-4 mpro-box" id="fifth-step">
        <mpro-spending-distribution
          [flag]="isCategoriesEnabled"
        ></mpro-spending-distribution>
      </div>
      <div>
        <p id="data-update-date">Data Updated 21 May 2025</p>
      </div>
    </div>
    <div id="sidebar" class="col-12 col-lg-8 order-first order-lg-last">
      <div class="mt-4 mpro-box" id="second-step">
        <mpro-map></mpro-map>
      </div>
      <div
        class="mt-4 mpro-box"
        id="sixth-step"
        *ngIf="!(authService.permissions$ | async)?.isFreemium"
      >
        <mpro-region-comparison></mpro-region-comparison>
      </div>
    </div>
  </div>
</div>

<mpro-export-data [(isModalOpen)]="exportDataModal"></mpro-export-data>
<mpro-freemium-pay-wall
  *ngIf="!(authService.isFreemiumIntroductionModalOpened$ | async)"
></mpro-freemium-pay-wall>
<mpro-upsale-modal></mpro-upsale-modal>
<ng-container
  *ngIf="authService.isFreemiumIntroductionModalOpened$ | async as isModalOpen"
>
  <mpro-freemium-introduction
    [isModalOpen]="isModalOpen"
  ></mpro-freemium-introduction>
</ng-container>
<mpro-categories-consumer-message></mpro-categories-consumer-message>
